/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_Home_ButtonInputs */

const en_go_to_home_button = /** @type {(inputs: Go_To_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Home`)
};

const nl_go_to_home_button = /** @type {(inputs: Go_To_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar Start`)
};

/**
* | output |
* | --- |
* | "Go to Home" |
*
* @param {Go_To_Home_ButtonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const go_to_home_button = /** @type {((inputs?: Go_To_Home_ButtonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_Home_ButtonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_go_to_home_button(inputs)
	return en_go_to_home_button(inputs)
});